import { UserAccess, userAccessApiResponseSchema } from '@repo/shared/domain';
import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getUserAccess = async (
	userId: string,
	params?: { page?: number; pageSize?: number; sort?: string },
): Promise<{ data: UserAccess[]; count: number; page: number; pageSize: number }> => {
	const searchParams = new URLSearchParams();
	if (params?.page !== undefined) searchParams.set('page', params.page.toString());
	if (params?.pageSize !== undefined) searchParams.set('pageSize', params.pageSize.toString());
	if (params?.sort) searchParams.set('sort', params.sort);

	const { body } = await clientRequest.get(`/api/users/${userId}/access?${searchParams.toString()}`, {
		schema: userAccessApiResponseSchema,
	});
	return body;
};

export const getExternalAccess = async (
	userId: string,
	params?: { page?: number; pageSize?: number },
): Promise<{ data: UserAccess[]; count: number; page: number; pageSize: number }> => {
	const searchParams = new URLSearchParams();
	if (params?.page !== undefined) searchParams.set('page', params.page.toString());
	if (params?.pageSize !== undefined) searchParams.set('pageSize', params.pageSize.toString());

	const { body } = await clientRequest.get(`/api/users/${userId}/zone-access-proxy?${searchParams.toString()}`, {
		schema: userAccessApiResponseSchema,
	});
	return body;
};
